/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Label_Phone_OptInputs */

const en_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone (optional)`)
};

const es_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teléfono (opcional)`)
};

const de_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (optional)`)
};

const zh_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电话（可选）`)
};

const ar_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهاتف (اختياري)`)
};

const fr_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphone (facultatif)`)
};

const vi_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điện thoại (không bắt buộc)`)
};

const sw_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simu (ya hiari)`)
};

const th_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โทรศัพท์ (ไม่จำเป็น)`)
};

const bs_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (opcionalno)`)
};

const ja_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電話(任意)`)
};

const ko_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전화 (선택)`)
};

const pt_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefone (opcional)`)
};

const it_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefono (opzionale)`)
};

const sv_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (valfritt)`)
};

const nl_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefoon (facultatief)`)
};

const da_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (valgfrit)`)
};

const nb_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (valgfritt)`)
};

const fi_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puhelin (vapaaehtoinen)`)
};

const pl_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (opcjonalny)`)
};

const ru_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телефон (необязательно)`)
};

const tr_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (isteğe bağlı)`)
};

const hi_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फोन (वैकल्पिक)`)
};

const id_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telepon (opsional)`)
};

const ms_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (pilihan)`)
};

const cs_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (nepovinné)`)
};

const el_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τηλέφωνο (προαιρετικό)`)
};

const he_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טלפון (אופציונלי)`)
};

const af_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefoon (opsioneel)`)
};

const hu_contact_label_phone_opt = /** @type {(inputs: Contact_Label_Phone_OptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (nem kötelező)`)
};

/**
* | output |
* | --- |
* | "Phone (optional)" |
*
* @param {Contact_Label_Phone_OptInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_label_phone_opt = /** @type {((inputs?: Contact_Label_Phone_OptInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Label_Phone_OptInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_label_phone_opt(inputs)
	if (locale === "de") return de_contact_label_phone_opt(inputs)
	if (locale === "zh") return zh_contact_label_phone_opt(inputs)
	if (locale === "ar") return ar_contact_label_phone_opt(inputs)
	if (locale === "fr") return fr_contact_label_phone_opt(inputs)
	if (locale === "vi") return vi_contact_label_phone_opt(inputs)
	if (locale === "sw") return sw_contact_label_phone_opt(inputs)
	if (locale === "th") return th_contact_label_phone_opt(inputs)
	if (locale === "bs") return bs_contact_label_phone_opt(inputs)
	if (locale === "ja") return ja_contact_label_phone_opt(inputs)
	if (locale === "ko") return ko_contact_label_phone_opt(inputs)
	if (locale === "pt") return pt_contact_label_phone_opt(inputs)
	if (locale === "it") return it_contact_label_phone_opt(inputs)
	if (locale === "sv") return sv_contact_label_phone_opt(inputs)
	if (locale === "nl") return nl_contact_label_phone_opt(inputs)
	if (locale === "da") return da_contact_label_phone_opt(inputs)
	if (locale === "nb") return nb_contact_label_phone_opt(inputs)
	if (locale === "fi") return fi_contact_label_phone_opt(inputs)
	if (locale === "pl") return pl_contact_label_phone_opt(inputs)
	if (locale === "ru") return ru_contact_label_phone_opt(inputs)
	if (locale === "tr") return tr_contact_label_phone_opt(inputs)
	if (locale === "hi") return hi_contact_label_phone_opt(inputs)
	if (locale === "id") return id_contact_label_phone_opt(inputs)
	if (locale === "ms") return ms_contact_label_phone_opt(inputs)
	if (locale === "cs") return cs_contact_label_phone_opt(inputs)
	if (locale === "el") return el_contact_label_phone_opt(inputs)
	if (locale === "he") return he_contact_label_phone_opt(inputs)
	if (locale === "af") return af_contact_label_phone_opt(inputs)
	if (locale === "hu") return hu_contact_label_phone_opt(inputs)
	return en_contact_label_phone_opt(inputs)
});